import { createApp, provide } from "vue";
import personItemList from "../../../templates/component/person-item-list/PersonItemList.vue";


const personItemListSelector = '.component-person-item-list';

const initPersonItemList = () => {
// update according to component name
const appId = "person-item-list";

const el = document.getElementById(appId);
if (el) {
  const app = createApp({
    components: {
      personItemList,
    },
    setup() {
      // use provide to be able to access value from nested components
      provide("componentId", appId);
    },
  });
  app.mount(el);
}
}

export { personItemListSelector, initPersonItemList };
